__turbopack_context__.v({
  "errorBoundary": "error-boundary-module-scss-module__KdSbIG__errorBoundary",
  "feedbackButton": "error-boundary-module-scss-module__KdSbIG__feedbackButton",
  "subHeading": "error-boundary-module-scss-module__KdSbIG__subHeading",
});
